module.exports = __webpack_public_path__ + "img/ep-panneau-1.37032732.png";